module.exports = __webpack_public_path__ + "img/avatar_10.ee0192c7.svg";